/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCustomerGroupV1Dto } from '../models/CreateCustomerGroupV1Dto';
import type { CustomerGroupV1Dto } from '../models/CustomerGroupV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchCustomerGroupV1Dto } from '../models/PatchCustomerGroupV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerGroupsService {
  /**
   * @param requestBody
   * @returns CustomerGroupV1Dto create entity
   * @throws ApiError
   */
  public static customerGroupControllerV1CreateV1(
    requestBody: CreateCustomerGroupV1Dto,
  ): CancelablePromise<CustomerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/customer-groups',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns CustomerGroupV1Dto a entity list
   * @throws ApiError
   */
  public static customerGroupControllerV1FindAllV1(): CancelablePromise<Array<CustomerGroupV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customer-groups',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static customerGroupControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customer-groups',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid customerGroupId
   * @returns CustomerGroupV1Dto the entity
   * @throws ApiError
   */
  public static customerGroupControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<CustomerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customer-groups/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid customerGroupId
   * @param requestBody
   * @returns CustomerGroupV1Dto the update entity
   * @throws ApiError
   */
  public static customerGroupControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchCustomerGroupV1Dto,
  ): CancelablePromise<CustomerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/customer-groups/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid customerGroupId
   * @returns CustomerGroupV1Dto the entity
   * @throws ApiError
   */
  public static customerGroupControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<CustomerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customer-groups/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
